import { RootAppState } from 'store/types';
import { objectToArray } from 'utils/object';

export const getCountListItem = (state: RootAppState): number => Object.keys(state.checklist).length;

export const getCountCheckedListItem = (state: RootAppState): number => objectToArray(state.checklist).filter(item => item.isChecked).length;

export const getChecklistProgress = (state: RootAppState): number => (getCountCheckedListItem(state) / getCountListItem(state)) * 100;

export const getStateOfCheckListItem = (state: RootAppState, itemId: string) => state.checklist[itemId] && state.checklist[itemId].isChecked;
